<template>
  <div>
    <!-- Toast组件 -->
    <div v-if="showToastFlag" class="toast">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showToastFlag: false,
      message: ""
    };
  },
  methods: {
    showToast(msg) {
      console.log('执行',msg);
      // 设置Toast的内容和显示标志
      this.message = msg;
      this.showToastFlag = true;

      // 一定时间后隐藏Toast（例如：3秒）
      setTimeout(() => {
        this.showToastFlag = false;
      }, 3000);
    }
  }
};
</script>

<style>
/* Toast样式 */
.toast {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 16px;
  border-radius: 8px;
  z-index: 10;
}
</style>